import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { GlobalNamespace as _GlobalNS } from './../../../environments/environment';
import { FormBuilder } from '@angular/forms';
import { GlobalService } from '../../core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/forms";
import * as i3 from "../../core/global.service";
var httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};
var ConfigurationService = /** @class */ (function () {
    function ConfigurationService(_http, fb, _global) {
        this._http = _http;
        this.fb = fb;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.relationshipType = new BehaviorSubject([]);
        this.configurationType = new BehaviorSubject([]);
        this.getRelationshipType = this.relationshipType.asObservable();
        this.getConfigurationType = this.configurationType.asObservable();
    }
    ConfigurationService.prototype.setRelationshipType = function (data) {
        this.relationshipType.next(data);
    };
    ConfigurationService.prototype.setConfigurationType = function (type, config) {
        this.configurationType.next({ type: type, config: config });
    };
    ConfigurationService.prototype.update = function (data) {
        var api = _GlobalNS.api.setting.partner.type;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, data, this.httpOptions);
    };
    ConfigurationService.prototype.findRelationshipTypes = function () {
        var api = _GlobalNS.api.setting.partner.type;
        return this._http.get(api);
    };
    // STEP TWO
    ConfigurationService.prototype.findByRelationshipTypeID = function (id) {
        var api = _GlobalNS.api.setting.partner.typeById;
        var params = new HttpParams().set('RelationshipTypeId', id).set('ResultType', 'ALL');
        return this._http.get(api, { params: params });
    };
    ConfigurationService.prototype.findRelationshipTypeConfigurations = function () {
        var configs = [];
        this.findRelationshipTypes().subscribe(function (data) {
            var rtypes = data.data;
        });
    };
    ConfigurationService.prototype.findRelationshipTypeSettingsByAccessTypeId = function (id) {
        var params = new HttpParams().set('AccessTypeId', id);
        var api = '/assets/data/mock-relationshiptypesettings.json';
        return this._http.get(api, { params: params });
    };
    ConfigurationService.prototype.save = function (configuration) {
        var api = _GlobalNS.api.setting.partner.save;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, configuration, this.httpOptions);
    };
    ConfigurationService.ngInjectableDef = i0.defineInjectable({ factory: function ConfigurationService_Factory() { return new ConfigurationService(i0.inject(i1.HttpClient), i0.inject(i2.FormBuilder), i0.inject(i3.GlobalService)); }, token: ConfigurationService, providedIn: "root" });
    return ConfigurationService;
}());
export { ConfigurationService };
